import { Button } from '@ps-design-system/components/Button';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const IdentityVerificationButton = React.forwardRef(
  (
    { errorMsg, retry, onClick, stripeInstance, isLoading, locale, fieldValue },
    ref
  ) => {
    // if fieldValue is empty, no attempt has been made to verify identity
    return errorMsg && fieldValue ? (
      <div style={{ display: 'flex', gap: '8px' }}>
        {retry && (
          <Button
            ref={ref}
            testId="retry-identity-verification-btn"
            onClick={onClick}
            disabled={!stripeInstance}
            showSpinner={isLoading}
          >
            <FormattedMessage
              id="identity_verification.try_again"
              defaultMessage="Try Again"
            />
          </Button>
        )}
        <Button
          variant="outline-1"
          appearance="white"
          href={`https://support.peerspace.com/hc/${locale?.toLowerCase()}/requests/new`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FormattedMessage
            id="identity_verification.contact_support"
            defaultMessage="Contact Support"
          />
        </Button>
      </div>
    ) : (
      <Button
        ref={ref}
        testId="verify-identity-btn"
        onClick={onClick}
        disabled={!stripeInstance}
        showSpinner={isLoading}
      >
        <FormattedMessage
          id="identity_verification.verify_identity"
          defaultMessage="Verify identity"
        />
      </Button>
    );
  }
);
IdentityVerificationButton.displayName = 'IdentityVerificationButton';
IdentityVerificationButton.propTypes = {
  errorMsg: PropTypes.string,
  retry: PropTypes.bool,
  onClick: PropTypes.func,
  stripeInstance: PropTypes.object,
  isLoading: PropTypes.bool,
  locale: PropTypes.string,
  fieldValue: PropTypes.string
};
